import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Progress, Switch, Tag, Popconfirm } from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";

import "./index.css";
import SingleDetailsRowWithLabelAndValue from "../../connectionDetails/cards/SingleDetailsRowWithLabelAndValue";
import UserBlue from "./../../../assets/svgs/UserProfileIcons/UserProfileBlue.svg";
import CNICBlue from "./../../../assets/svgs/UserProfileIcons/CNICBlue.svg";
import DesignationBlue from "./../../../assets/svgs/UserProfileIcons/DesignationBlue.svg";
import PasswordBlue from "./../../../assets/svgs/UserProfileIcons/PasswordBlue.svg";
import ShutDownBlue from "./../../../assets/svgs/UserProfileIcons/ShutDownBlue.svg";
import WalletBlue from "./../../../assets/svgs/UserProfileIcons/WalletBlue.svg";
import LocationIcon from "./../../../assets/svgs/ProfileIcons/Location.svg";
import useAxiosPost from "../../../hooks/useAxiosPost";
import useMultiNotification from "../../../hooks/useNotification";
import UpdateStaffStatusConfirmationModal from "../../Modals/UpdateStaffStatusModal";
import UpdateStaffPasswordModal from "../../Modals/UpdateStaffPasswordModal";
import AssignAreasToStaffModal from "../../Modals/AssignAreasToStaffModal";
import UpdateStaffAreaLimitTypeModal from "../../Modals/UpdateStaffAreaLimitTypeModal";
import { getUserType } from "../../../helpers/userDetails";
const StaffProfileTabCard: React.FC<StaffListMiniCardProp> = ({
  staff,
  staffApiReload,
  isStaff,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [selectedOption, setSelectedOption] = useState<boolean>(
    Boolean(staff.enable)
  );
  const [
    postUpdateProfileApi,
    updateProfileApiResponse,
    updateProfileApiError,
    updateProfileApiLoading,
    updateProfileApiMessage,
    updateProfileApiErrorCount,
  ] = useAxiosPost<UpdateStaffStatusApiProp>("auth/updateMyStaffStatus", true);
  const [
    unassignAreaApi,
    unassignAreaApiResponse,
    unassignAreaApiError,
    unassignAreaApiLoading,
    unassignAreaApiMessage,
    unassignAreaApiErrorCount,
  ] = useAxiosPost<any>("areas/UnassignAreaFromStaff", true);
  const [
    updateStaffAreaLimitTypeApi,
    updateStaffAreaLimitTypeApiResponse,
    updateStaffAreaLimitTypeApiError,
    updateStaffAreaLimitTypeApiLoading,
    updateStaffAreaLimitTypeApiMessage,
    updateStaffAreaLimitTypeApiErrorCount,
  ] = useAxiosPost<any>("auth/updateMyStaffAreaLimitType", true);
  const [show, setShow] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showAssignAreasModal, setShowAssignAreasModal] =
    useState<boolean>(false);
  const [showUpdateStaffTypeModal, setShowUpdateStaffTypeModal] =
    useState<boolean>(false);
  const onChange = (checked: boolean) => {
    setSelectedOption(checked);
    setShow(true);
  };
  const handleClick = () => {
    setShowPassword(true);
  };
  const handleUpdateStatus = (isChange: boolean) => {
    if (isChange === true) {
      //lets call the api
      postUpdateProfileApi({
        enable: Number(selectedOption),
        intPkHeadID: staff.intPkHeadID,
      });
    }
    setShow(false);
  };
  useEffect(() => {
    if (updateProfileApiResponse !== null) {
      const { message } = updateProfileApiResponse;
      if (message) {
        staffApiReload(true);
        openNotification(`success`, "Success", message);
      }
    }
  }, [updateProfileApiResponse]);
  useEffect(() => {
    if (updateProfileApiError !== null && updateProfileApiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", updateProfileApiError);
    }
  }, [updateProfileApiError, updateProfileApiErrorCount]);
  useEffect(() => {
    if (unassignAreaApiResponse !== null) {
      const { message } = unassignAreaApiResponse;
      if (message) {
        staffApiReload(true);
        openNotification(`success`, "Success", message);
      }
    }
  }, [unassignAreaApiResponse]);
  useEffect(() => {
    if (unassignAreaApiError !== null && unassignAreaApiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", unassignAreaApiError);
    }
  }, [unassignAreaApiError, unassignAreaApiErrorCount]);
  useEffect(() => {
    if (updateStaffAreaLimitTypeApiResponse !== null) {
      const { message } = updateStaffAreaLimitTypeApiResponse;
      if (message) {
        staffApiReload(true);
        openNotification(`success`, "Success", message);
      }
    }
  }, [updateStaffAreaLimitTypeApiResponse]);
  useEffect(() => {
    if (
      updateStaffAreaLimitTypeApiError !== null &&
      updateStaffAreaLimitTypeApiErrorCount !== 0
    ) {
      openNotification(
        `error`,
        "Operation Failed",
        updateStaffAreaLimitTypeApiError
      );
    }
  }, [updateStaffAreaLimitTypeApiError, updateStaffAreaLimitTypeApiErrorCount]);
  const handleUnassignArea = (areaId: number) => {
    unassignAreaApi({
      areaId: areaId,
      staffId: staff.intPkHeadID,
    });
  };
  const handleClose = (isReload: boolean) => {
    if (isReload) {
      staffApiReload(true);
    }
    setShowPassword(false);
  };
  const handleCloseAssignAreasModal = (isReload?: boolean) => {
    setShowAssignAreasModal(false);
    if (isReload) {
      staffApiReload(true);
    }
  };
  const handleEditStaffType = () => {
    setShowUpdateStaffTypeModal(true);
  };
  const handleUpdateStaffType = (
    isChange: boolean,
    newType?: "AREA_WISE" | "COMPANY_WISE"
  ) => {
    setShowUpdateStaffTypeModal(false);
    if (isChange === true && newType) {
      updateStaffAreaLimitTypeApi({
        intPkHeadID: staff.intPkHeadID,
        staffAreaLimitType: newType,
      });
    }
  };
  return (
    <>
      {show && (
        <UpdateStaffStatusConfirmationModal
          show={show}
          handleClose={handleUpdateStatus}
          status={selectedOption}
        />
      )}
      {showPassword && (
        <UpdateStaffPasswordModal
          show={showPassword}
          handleClose={handleClose}
          intPkHeadID={staff.intPkHeadID}
          apiUrl="auth/updateMyStaffPassword"
        />
      )}
      {showAssignAreasModal && (
        <AssignAreasToStaffModal
          show={showAssignAreasModal}
          handleClose={handleCloseAssignAreasModal}
          staffId={staff.intPkHeadID}
          assignedAreas={staff.areas || []}
        />
      )}
      {showUpdateStaffTypeModal && (
        <UpdateStaffAreaLimitTypeModal
          show={showUpdateStaffTypeModal}
          handleClose={handleUpdateStaffType}
          currentType={staff.staffAreaLimitType}
        />
      )}

      {contextHolder}
      <Row className="staff-profile-tab-container">
        <SingleDetailsRowWithLabelAndValue
          value={`${staff.phoneNumber}`}
          label="Phone Number"
          icon={UserBlue}
        />
        <SingleDetailsRowWithLabelAndValue
          value={`${staff.staffUserName}`}
          label="Username"
          icon={DesignationBlue}
        />
        {/* <SingleDetailsRowWithLabelAndValue
          value={`${staff.nicNumber ? staff.nicNumber : "None"}`}
          label="CNIC Number"
          icon={CNICBlue}
        /> */}
        <SingleDetailsRowWithLabelAndValue
          value={`${staff.headType}`}
          label="Designation"
          icon={DesignationBlue}
        />
        {["RMAN", "CASHIER"].includes(staff.headType) && (
          <>
            <SingleDetailsRowWithLabelAndValue
              value={`${staff.walletLimit} Rs`}
              label="Wallet Limit"
              icon={WalletBlue}
            />
            <SingleDetailsRowWithLabelAndValue
              value={`${staff.walletDays} Days`}
              label="Wallet Days"
              icon={WalletBlue}
              isBorderBottom={isStaff}
            />
          </>
        )}

        {isStaff === true &&
          ["LINEMAN", "RMAN", "CASHIER"].includes(staff.headType) &&
          staff.staffAreaLimitType && (
            <SingleDetailsRowWithLabelAndValue
              value={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span>
                    {staff.staffAreaLimitType === "AREA_WISE"
                      ? "Area Wise"
                      : "Company Wise"}
                  </span>
                  {getUserType() === "CEO" && (
                    <EditOutlined
                      onClick={handleEditStaffType}
                      style={{
                        cursor: "pointer",
                        color: "#1890ff",
                        fontSize: "14px",
                      }}
                    />
                  )}
                </div>
              }
              label="Connection View Type"
              icon={LocationIcon}
              isReactNode={true}
              isBorderBottom={staff.staffAreaLimitType === "AREA_WISE"}
            />
          )}

        {staff.staffAreaLimitType === "AREA_WISE" && (
          <SingleDetailsRowWithLabelAndValue
            value={
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                {staff.areas && staff.areas.length > 0 ? (
                  <>
                    {staff.areas.map((area) => (
                      <Tag
                        key={area.intPkAreaID}
                        color="blue"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "4px 8px",
                        }}
                      >
                        <span>{area.areaName}</span>
                        {isStaff === true && getUserType() === "CEO" && (
                          <Popconfirm
                            title="Unassign Area"
                            description={`Are you sure you want to unassign "${area.areaName}"?`}
                            onConfirm={() =>
                              handleUnassignArea(area.intPkAreaID)
                            }
                            okText="Yes"
                            cancelText="No"
                            okButtonProps={{
                              loading: unassignAreaApiLoading,
                            }}
                          >
                            <DeleteOutlined
                              style={{
                                cursor: "pointer",
                                color: "#ff4d4f",
                                fontSize: "12px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            />
                          </Popconfirm>
                        )}
                      </Tag>
                    ))}
                  </>
                ) : (
                  <Typography style={{ color: "#999", fontSize: "14px" }}>
                    No areas assigned
                  </Typography>
                )}
                {isStaff === true && getUserType() === "CEO" && (
                  <PlusOutlined
                    onClick={() => setShowAssignAreasModal(true)}
                    style={{
                      cursor: "pointer",
                      color: "#1890ff",
                      fontSize: "16px",
                      marginLeft: "8px",
                    }}
                  />
                )}
              </div>
            }
            label="Assigned Areas"
            icon={LocationIcon}
            isReactNode={true}
            fullWidthValue={true}
            isBorderBottom={isStaff}
          />
        )}

        {isStaff === true && (
          <>
            <SingleDetailsRowWithLabelAndValue
              value={`Change Password`}
              label="Password"
              icon={PasswordBlue}
              isUnderline
              onClick={handleClick}
            />
            <SingleDetailsRowWithLabelAndValue
              value={
                <span>
                  {" "}
                  <Switch
                    checked={Boolean(staff.enable)}
                    onChange={onChange}
                  />{" "}
                  Active
                </span>
              }
              label="User Status"
              icon={ShutDownBlue}
              isBorderBottom={false}
              isReactNode={true}
            />
          </>
        )}
      </Row>
    </>
  );
};
export default StaffProfileTabCard;
